import { css, html } from 'lit';
import { t } from 'src/i18n';
import '../../library/elements/d-tooltip.js';
import '../../library/elements/d-label.js';
import './d-risk-gradient.js';
import { customElement, property } from 'lit/decorators.js';
import { LabeledElement } from '../../library/abstracts/labeled-element.js';
import { riskLevelFromRisk } from 'src/models/risk.js';

/**
 *
 * STATUS OK
 */
@customElement('d-view-risk')
export class DViewRisk extends LabeledElement {
  static readonly styles = [
    super.styles[0],
    css`
      d-risk-gradient {
        height: 12px;
        border-radius: 6px;
      }

      .riskVisualizer table {
        margin-top: 0;
        margin-bottom: -12px;
      }

      .riskVisualizer table td.selected {
        color: black;
        font-weight: bold;
      }

      .riskVisualizer table td {
        width: 25%;
        text-align: center;
        color: silver;
        padding: 10px 4px 20px 4px;
        min-height: 40px;
        line-height: 15px;
        border: 0;
        font-family: inherit;
        font-size: 100%;
        font-style: inherit;
        font-weight: inherit;
        margin: 0;
        outline: 0;
        vertical-align: top;
      }

      body:not(.touch) .riskVisualizer table td:hover,
      .riskVisualizer table td:active {
        color: black;
      }

      body:not(.touch) :host .riskVisualizer table td:hover,
      :host .riskVisualizer table td:active {
        cursor: default;
        color: silver;
      }

      body:not(.touch) :host .riskVisualizer table td.selected:hover,
      :host .riskVisualizer table td.selected:active {
        color: black;
      }

      .riskVisualizer .measures {
        margin-top: 4px;
        display: none;
      }

      .riskVisualizer td.selected .measures {
        font-weight: normal;
        display: block;
      }
    `,
  ];
  field = 'riskAssessments_calculatedRisk';
  /**
   * The value. The combined risk as score between 1 and 16. For unknown use 0.
   */
  @property({ type: Number })
  value = 0;

  _computeClass(level) {
    let _class = 'result' + level;
    _class += riskLevelFromRisk(this.value) === level ? ' selected' : '';
    return _class;
  }

  renderContent() {
    return html`
      <div class="riskVisualizer">
        <d-risk-gradient .value=${this.value}></d-risk-gradient>
        <table border="0" cellpadding="0" cellspacing="0" width="100%" role="presentation">
          <tbody>
            <tr>
              <td class="${this._computeClass(1)}">
                ${t('riskAssessments.probabilityLow')}
                <div class="measures">${t('riskAssessments.measuresCanBeConsidered')}</div>
              </td>
              <td class="${this._computeClass(2)}">
                ${t('riskAssessments.probabilityModerate')}
                <div class="measures">${t('riskAssessments.measuresShallBeConsidered')}</div>
              </td>
              <td class="${this._computeClass(3)}">
                ${t('riskAssessments.probabilityHigh')}
                <div class="measures">${t('riskAssessments.measuresShouldBeDecided')}</div>
              </td>
              <td class="${this._computeClass(4)}">
                ${t('riskAssessments.probabilityVeryHigh')}
                <div class="measures">${t('riskAssessments.measuresMustBeDecided')}</div>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    `;
  }
}

declare global {
  interface HTMLElementTagNameMap {
    'd-view-risk': DViewRisk;
  }
}
